import { notify } from 'utils/reduxUtils';

import * as types from './types';

export const fetchSupplierSuccess = (payload, entities) => ({
  type: types.FETCH_SUCCESS,
  payload,
  meta: { entities },
});

export const reset = () => ({
  type: types.RESET,
});

export const getTeamMembers = {
  success: ({ teamMembers }) => ({
    type: types.GET_TEAM_MEMBERS_SUCCESS,
    payload: { teamMembers },
  }),
  error: notify(
    ({ error }) => ({
      type: types.GET_TEAM_MEMBERS_ERROR,
      payload: error,
    }),
    "Can't get team members",
  ),
};

export const getTeamMember = {
  success: ({ teamMember }) => ({
    type: types.GET_TEAM_MEMBER_SUCCESS,
    payload: { teamMember },
  }),
  error: notify(
    ({ error }) => ({
      type: types.GET_TEAM_MEMBER_ERROR,
      payload: error,
    }),
    "Can't get team member",
  ),
};

export const createTeamMember = {
  request: ({ teamMember }) => ({
    type: types.CREATE_TEAM_MEMBER_REQUEST,
    payload: { teamMember },
  }),
  success: notify(
    ({ response }) => ({
      type: types.CREATE_TEAM_MEMBER_SUCCESS,
      payload: response,
    }),
    ({ payload }) => {
      if (payload.email) {
        if (payload.isNewUser) {
          return `Invitation sent to ${payload.email}`;
        } else {
          return `Added ${payload.email} to organization`;
        }
      } else {
        return '';
      }
    },
  ),
  error: notify(
    ({ error }) => ({
      type: types.CREATE_TEAM_MEMBER_ERROR,
      payload: error,
    }),
    "Can't add team member",
  ),
};

export const disableTeamMemberAuth = {
  request: ({ teamMember }) => ({
    type: types.DISABLE_TEAM_MEMBER_AUTH_REQUEST,
    payload: { teamMember },
  }),
  success: notify(
    ({ teamMember }) => ({
      type: types.DISABLE_TEAM_MEMBER_AUTH_SUCCESS,
      payload: { teamMember },
    }),
    'Successfully disabled team member 2FA.',
  ),
  error: notify(
    () => ({
      type: types.DISABLE_TEAM_MEMBER_AUTH_ERROR,
    }),
    "Can't disabled team member 2FA.",
  ),
};

export const updateTeamMember = {
  request: ({ teamMember, cb }) => ({
    type: types.UPDATE_TEAM_MEMBER_REQUEST,
    payload: { teamMember, cb },
  }),
  success: notify(
    ({ teamMember }) => ({
      type: types.UPDATE_TEAM_MEMBER_SUCCESS,
      payload: { teamMember },
    }),
    'Team member successfully updated',
  ),
  error: notify(
    ({ error }) => ({
      type: types.UPDATE_TEAM_MEMBER_ERROR,
      payload: error,
    }),
    "Can't update team member",
  ),
};

export const deleteTeamMember = {
  request: ({ teamMemberId }) => ({
    type: types.DELETE_TEAM_MEMBER_REQUEST,
    payload: { teamMemberId },
  }),
  success: notify(
    ({ teamMemberId }) => ({
      type: types.DELETE_TEAM_MEMBER_SUCCESS,
      payload: { teamMemberId },
    }),
    'Team member successfully deleted',
  ),
  error: notify(
    ({ error }) => ({
      type: types.DELETE_TEAM_MEMBER_ERROR,
      payload: error,
    }),
    "Can't delete team member",
  ),
};

export const resendInvite = {
  request: ({ emailAddress }) => ({
    type: types.TEAM_MEMBER_INVITE_RESEND_REQUEST,
    payload: { emailAddress },
  }),
  success: notify(
    ({ response }) => ({
      type: types.TEAM_MEMBER_INVITE_RESEND_SUCCESS,
      payload: response,
    }),
    ({ payload }) =>
      payload.email ? `Invitation sent to ${payload.email}` : '',
  ),
  error: notify(
    (error) => ({
      type: types.TEAM_MEMBER_INVITE_RESEND_ERROR,
      payload: error,
    }),
    'Failed to resend invite.',
  ),
};

export const initCreateTeamMember = (payload) => ({
  type: types.CREATE_TEAM_MEMBER,
  payload: payload,
});

export const sendVerificationEmail = {
  request: ({ teamMemberId }) => ({
    type: types.SEND_VERIFICATION_EMAIL_REQUEST,
    payload: { teamMemberId },
  }),
  success: notify(
    () => ({
      type: types.SEND_VERIFICATION_EMAIL_SUCCESS,
    }),
    'Verification email sent.',
  ),
  error: notify(
    ({ error }) => ({
      type: types.SEND_VERIFICATION_EMAIL_ERROR,
      payload: error,
    }),
    'Something went wrong when sending the verification email.',
  ),
};

export const checkEmailVerification = {
  request: ({ teamMemberId }) => ({
    type: types.CHECK_EMAIL_VERIFICATION_REQUEST,
    payload: { teamMemberId },
  }),
  success: ({ isVerified }) => ({
    type: types.CHECK_EMAIL_VERIFICATION_SUCCESS,
    payload: { isVerified },
  }),
  error: notify(
    ({ error }) => ({
      type: types.CHECK_EMAIL_VERIFICATION_ERROR,
      payload: error,
    }),
    'Something went wrong when checking email verification.',
  ),
};
